import {useRef, useState} from "react";
import {css} from "@panda/css";
import {AnimatePresence} from "framer-motion";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {ViewType} from "../../view_type/ViewType";
import {getFavouritesDropdownLocation, getFavouritesShowAllButtonCategory} from "../tracking/get_favourites_show_all_button_category";
import {FAVOURITES_TOPBAR_PREVIEW_LIMIT, IFavouritesTopbarCard} from "../utils/map_favourite_to_topbar_card";
import {FavouritesTopbarCard} from "./FavouritesTopbarCard";
import {FavouritesTopbarEmptyState} from "./FavouritesTopbarEmptyState";

interface IProps {
    cards: IFavouritesTopbarCard[];
    count: number;
    dropdownId: string;
    favouritesListLink: string;
    viewType: ViewType | null;
}

interface IOutgoingCard {
    card: IFavouritesTopbarCard;
    top: number;
}

export const FavouritesTopbarDropdown = (props: IProps) => {
    const {cards, count, dropdownId, favouritesListLink, viewType} = props;
    const listRef = useRef<HTMLUListElement>(null);
    const [exitingIds, setExitingIds] = useState<number[]>([]);
    const [listHeight, setListHeight] = useState<number>();
    const [outgoingCards, setOutgoingCards] = useState<IOutgoingCard[]>([]);
    const remainingCards = cards.filter((card) => !exitingIds.includes(card.propertyId));
    const visibleCards = remainingCards.slice(0, FAVOURITES_TOPBAR_PREVIEW_LIMIT);
    const showCards = visibleCards.length > 0 || outgoingCards.length > 0;
    const dropdownLocation = getFavouritesDropdownLocation(viewType);

    const handleShowAllClick = () => {
        trackAmplitudeButtonClick({
            buttonName: "rp_favourites_show_all",
            value: "hm_favourite_offers",
            buttonCategory: getFavouritesShowAllButtonCategory(viewType),
            itemId: null,
            buttonLink: favouritesListLink
        });
    };

    const handleDeleteStart = (propertyId: number) => {
        const list = listRef.current;
        const item = list?.querySelector(`[data-favourite-id="${propertyId}"]`);
        const card = cards.find((itemCard) => itemCard.propertyId === propertyId);

        setListHeight(list?.offsetHeight);
        if (card && item instanceof HTMLElement) {
            setOutgoingCards((current) =>
                current.some((outgoing) => outgoing.card.propertyId === propertyId) ? current : [...current, {card, top: item.offsetTop}]
            );
        }
        setExitingIds((ids) => (ids.includes(propertyId) ? ids : [...ids, propertyId]));
    };

    const removeOutgoingCard = (propertyId: number) => {
        setOutgoingCards((current) => current.filter((outgoing) => outgoing.card.propertyId !== propertyId));
        setExitingIds((ids) => {
            const next = ids.filter((id) => id !== propertyId);

            if (next.length === 0) {
                setListHeight(undefined);
            }

            return next;
        });
    };

    return (
        <div className={dropdownBodyStyle} data-testid={NAVIGATION_TEST_IDS.FAVOURITES.DROPDOWN} id={dropdownId}>
            <Text as="p" variant="headline_6">
                Ulubione
            </Text>
            {showCards ? (
                <div className={cardsContentStyle}>
                    <ul className={cardListStyle} ref={listRef} style={listHeight ? {height: listHeight} : undefined}>
                        <AnimatePresence initial={false}>
                            {visibleCards.map((card, index) => (
                                <FavouritesTopbarCard
                                    key={card.propertyId}
                                    card={card}
                                    index={index}
                                    location={dropdownLocation}
                                    onDeleteCancel={removeOutgoingCard}
                                    onDeleteStart={handleDeleteStart}
                                />
                            ))}
                        </AnimatePresence>
                        {outgoingCards.map((outgoing) => (
                            <FavouritesTopbarCard
                                key={`overlay-${outgoing.card.propertyId}`}
                                card={outgoing.card}
                                index={-1}
                                location={dropdownLocation}
                                onDeleteCancel={removeOutgoingCard}
                                onDeleteStart={handleDeleteStart}
                                onOverlayExitComplete={() => removeOutgoingCard(outgoing.card.propertyId)}
                                overlayTop={outgoing.top}
                            />
                        ))}
                    </ul>
                    <Button
                        as="a"
                        dataTestId={NAVIGATION_TEST_IDS.FAVOURITES.SHOW_ALL}
                        fullWidth
                        href={favouritesListLink}
                        onClick={handleShowAllClick}
                        size="medium"
                        variant="outlined_secondary"
                    >
                        Pokaż wszystkie ({count})
                    </Button>
                </div>
            ) : (
                <FavouritesTopbarEmptyState />
            )}
        </div>
    );
};

const dropdownBodyStyle = css({
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    p: 1,
    w: "30rem",
    bg: "var(--colors-white)",
    borderRadius: 1,
    boxShadow: "var(--shadow-1)"
});

const cardsContentStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mt: 2
});

const cardListStyle = css({
    display: "flex",
    position: "relative",
    flexDirection: "column",
    overflow: "hidden",
    gap: 1,
    m: 0,
    p: 0,
    listStyle: "none"
});
import {useRef, useState} from "react";
import {css} from "@panda/css";
import {AnimatePresence} from "framer-motion";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {NAVIGATION_TEST_IDS} from "@pg-mono/test-ids";

import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {ViewType} from "../../view_type/ViewType";
import {getFavouritesDropdownLocation, getFavouritesShowAllButtonCategory} from "../tracking/get_favourites_show_all_button_category";
import {FAVOURITES_TOPBAR_PREVIEW_LIMIT, IFavouritesTopbarCard} from "../utils/map_favourite_to_topbar_card";
import {FavouritesTopbarCard} from "./FavouritesTopbarCard";
import {FavouritesTopbarEmptyState} from "./FavouritesTopbarEmptyState";

interface IProps {
    cards: IFavouritesTopbarCard[];
    count: number;
    dropdownId: string;
    favouritesListLink: string;
    viewType: ViewType | null;
}

interface IOutgoingCard {
    card: IFavouritesTopbarCard;
    top: number;
}

export const FavouritesTopbarDropdown = (props: IProps) => {
    const {cards, count, dropdownId, favouritesListLink, viewType} = props;
    const listRef = useRef<HTMLUListElement>(null);
    const [exitingIds, setExitingIds] = useState<number[]>([]);
    const [listHeight, setListHeight] = useState<number>();
    const [outgoingCards, setOutgoingCards] = useState<IOutgoingCard[]>([]);
    const remainingCards = cards.filter((card) => !exitingIds.includes(card.propertyId));
    const visibleCards = remainingCards.slice(0, FAVOURITES_TOPBAR_PREVIEW_LIMIT);
    const showCards = visibleCards.length > 0 || outgoingCards.length > 0;
    const dropdownLocation = getFavouritesDropdownLocation(viewType);

    const handleShowAllClick = () => {
        trackAmplitudeButtonClick({
            buttonName: "rp_favourites_show_all",
            value: "hm_favourite_offers",
            buttonCategory: getFavouritesShowAllButtonCategory(viewType),
            itemId: null,
            buttonLink: favouritesListLink
        });
    };

    const handleDeleteStart = (propertyId: number) => {
        const list = listRef.current;
        const item = list?.querySelector(`[data-favourite-id="${propertyId}"]`);
        const card = cards.find((itemCard) => itemCard.propertyId === propertyId);

        setListHeight(list?.offsetHeight);
        if (card && item instanceof HTMLElement) {
            setOutgoingCards((current) =>
                current.some((outgoing) => outgoing.card.propertyId === propertyId) ? current : [...current, {card, top: item.offsetTop}]
            );
        }
        setExitingIds((ids) => (ids.includes(propertyId) ? ids : [...ids, propertyId]));
    };

    const removeOutgoingCard = (propertyId: number) => {
        setOutgoingCards((current) => current.filter((outgoing) => outgoing.card.propertyId !== propertyId));
        setExitingIds((ids) => {
            const next = ids.filter((id) => id !== propertyId);

            if (next.length === 0) {
                setListHeight(undefined);
            }

            return next;
        });
    };

    return (
        <div className={dropdownBodyStyle} data-testid={NAVIGATION_TEST_IDS.FAVOURITES.DROPDOWN} id={dropdownId}>
            <Text as="p" variant="headline_6">
                Ulubione
            </Text>
            {showCards ? (
                <div className={cardsContentStyle}>
                    <ul className={cardListStyle} ref={listRef} style={listHeight ? {height: listHeight} : undefined}>
                        <AnimatePresence initial={false}>
                            {visibleCards.map((card, index) => (
                                <FavouritesTopbarCard
                                    key={card.propertyId}
                                    card={card}
                                    index={index}
                                    location={dropdownLocation}
                                    onDeleteCancel={removeOutgoingCard}
                                    onDeleteStart={handleDeleteStart}
                                />
                            ))}
                        </AnimatePresence>
                        {outgoingCards.map((outgoing) => (
                            <FavouritesTopbarCard
                                key={`overlay-${outgoing.card.propertyId}`}
                                card={outgoing.card}
                                index={-1}
                                location={dropdownLocation}
                                onDeleteCancel={removeOutgoingCard}
                                onDeleteStart={handleDeleteStart}
                                onOverlayExitComplete={() => removeOutgoingCard(outgoing.card.propertyId)}
                                overlayTop={outgoing.top}
                            />
                        ))}
                    </ul>
                    <Button
                        as="a"
                        dataTestId={NAVIGATION_TEST_IDS.FAVOURITES.SHOW_ALL}
                        fullWidth
                        href={favouritesListLink}
                        onClick={handleShowAllClick}
                        size="medium"
                        variant="outlined_secondary"
                    >
                        Pokaż wszystkie ({count})
                    </Button>
                </div>
            ) : (
                <FavouritesTopbarEmptyState />
            )}
        </div>
    );
};

const dropdownBodyStyle = css({
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    p: 1,
    w: "30rem",
    bg: "var(--colors-white)",
    borderRadius: 1,
    boxShadow: "var(--shadow-1)"
});

const cardsContentStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mt: 2
});

const cardListStyle = css({
    display: "flex",
    position: "relative",
    flexDirection: "column",
    overflow: "hidden",
    gap: 1,
    m: 0,
    p: 0,
    listStyle: "none"
});
